<template>
  <router-view />
</template>

<script>
export default {
  name: 'CarManagementIndex'
}
</script>
